import { render, staticRenderFns } from "./ResultRanking.vue?vue&type=template&id=74fb4346&"
import script from "./ResultRanking.vue?vue&type=script&lang=js&"
export * from "./ResultRanking.vue?vue&type=script&lang=js&"
import style0 from "./ResultRanking.vue?vue&type=style&index=0&id=74fb4346&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports